module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp3_8003.77c9f1c6.png";